import { useState } from "react";
import { faqs } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="relative scroll-mt-24 bg-brand-50/50 py-10 md:py-14">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="lg:sticky lg:top-28">
            <SectionHead
              kicker="吃瓜指南 FAQ"
              title="先问真假，再论对错"
              desc="关于吃瓜前线的来源核实、更新机制与投稿方式，你关心的都在这里。也欢迎随时通过底部表单提问。"
              align="left"
              accent
            />
            <div className="mt-6 hidden rounded-2xl border border-gold-200 bg-white p-4 lg:block">
              <p className="text-[13px] font-semibold text-[#241b13]">吃瓜前线速递 · 内容原则</p>
              <ul className="mt-2.5 flex flex-col gap-2 text-[13px] leading-relaxed text-stone-600">
                <li className="flex gap-2">
                  <i className="ri-verified-badge-fill text-gold-500" /> 传闻与实锤分开标注，不冒充既成事实
                </li>
                <li className="flex gap-2">
                  <i className="ri-shield-check-fill text-brand-500" /> 涉及当事人，第一时间补全官方声明
                </li>
                <li className="flex gap-2">
                  <i className="ri-time-fill text-brand-500" /> 首发片段持续滚动更新，刷新越快料越足
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={
                  "overflow-hidden rounded-2xl border bg-white transition-colors " +
                  (isOpen ? "border-brand-200" : "border-stone-200")
                }
              >
                <button
                  className="flex w-full items-center gap-3 px-4 py-4 text-left md:px-5"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                >
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-100 font-heading text-[14px] font-black text-brand-700">
                    Q{i + 1}
                  </span>
                  <h3 className="flex-1 text-[15px] font-semibold leading-snug text-[#241b13] md:text-[16px]">
                    {f.q}
                  </h3>
                  <i
                    className={
                      "shrink-0 text-lg text-brand-600 transition-transform duration-300 " +
                      (isOpen ? "ri-subtract-line" : "ri-add-line")
                    }
                  />
                </button>
                <div className={"faq-body " + (isOpen ? "open" : "")}>
                  <div className="faq-inner">
                    <p className="border-t border-stone-100 px-4 pb-4 pt-3 text-[14px] leading-relaxed text-stone-600 md:px-5">
                      <span className="mr-2 rounded bg-gold-100 px-1.5 py-0.5 text-[11px] font-bold text-gold-700">答</span>
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}